import {ChangeDetectionStrategy, Component, ComponentFactoryResolver, Injector} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {PlayerContainer} from '../../player/player.container';
import {interval, mergeAll, mergeWith, Observable, of, switchMap, takeUntil} from 'rxjs';
import {catchError, delay, finalize, repeat} from "rxjs/operators";
import {DS_API_URL} from "../../constants";


@Component({
  selector: 'app-json-viewer',
  template: '<div #component><template #playercontainer></template></div>',
  styleUrls: [],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class JsonViewerComponent extends PlayerContainer {
  httpClient;
  unit;
  refreshEnabled = false;
  refreshTime = 3600 * 1000;

  constructor(protected  injector: Injector) {
    super(injector);
    this.httpClient = injector.get(HttpClient);
    this.displayMode='manual';
  }

  load(playerObject: any): Observable<any> {
    let self;
    return super.load(playerObject).pipe(
      switchMap( playerBase => {
        self = playerBase;
        if (this.data==null) {
        }
        const providerType = this.data.Json[0].$?.providerType;
        if (this.data.Json[0].$.minRefreshTime!=null && this.data.Json[0].$.minRefreshTime!="") {
          this.refreshEnabled = (this.data.Json[0].$.refreshEnabled == "1");
          this.refreshTime = (Number(this.data.Json[0].$.minRefreshTime) * 60 * 1000);
        }
        //???const itemInterval = this.data.Json[0].$.itemInterval;

        if (this.data.Json[0].$.volume!=null) {
          this.volume = Number(this.data.Json[0].$.volume);
        }

        if (providerType == 'weather') {
          this.unit = this.data.Json[0].Data[0].$.unit;
          this.refreshEnabled = true;
        }

        const src = this.data.Json[0].Player[0].$.src;
        if (src=="" || src=="-1") {
          this.showMsg(this.playerObject.$.label, 'No scene assigned');
          return of(null);
        } else {
          this.showMsg(null, null);

          if (this.editMode) {
            return this.showPage();
          }

          this.loadStat();

          return of('a');
        }
      }),
      catchError( err => this.logError(err) ),
      switchMap(a => of(self)),
      takeUntil(this.finish$)
    )
  }

  play(): Observable<any> {
    if (this.editMode) {
      this.display(true);
      return of('play');
    }

    let trigger$:Observable<any> = super.play();
    if (this.refreshEnabled) {
      trigger$ = trigger$.pipe(
        mergeWith(interval(this.refreshTime))
      )
    }

    return trigger$.pipe(
      switchMap(r1 => this.loadProviderData()),
      catchError( err => of(null)),  // fail to load url
      switchMap(value => this.invalidateData(value) ),
    )
  }

  invalidateData(providerData: any): Observable<any> {
    if (providerData==null) {
      return of(null);
    }
    this.providerData = providerData;
    this.childProviderData = this.providerData;
    return this.showPage();
  }

  getPage(): Observable<any> {
    return new Observable<any>( sub => {
      const player = this.data.Json[0].Player[0];
      sub.next(player);
      sub.complete();
    })
  }


  loadProviderData(): Observable<any> {
    const source = this.data.DataProvider[0].$.source;
    let folder = 'rss';
    if (this.data==null) {
      return of(null);
    }
    if (this.playerObject.$.player === '6010') {
      const address = this.data.Json[0].Data[0].$.address;
      const style = this.data.Json[0].Data[0].$.style;
      this.url = this.data.DataProvider[0].$.url;
      this.url += '/' + address + '/' + style;
      this.data.DataProvider[0].$.source = 'external'; // fix studio save
    } else if (this.playerObject.$.player === '6022') {
      this.url = DS_API_URL + "GoogleSheetsValues/" + this.data.Json[0].Data[0].$.token + "/" + this.data.Json[0].Data[0].$.id + "/0/";
    }
    else {
      if (source == 'cloud') {
        folder = 'eventparams'
      } else if (source == 'external') {
        const metadata = this.data.DataProvider[0].$.metadata;
        folder = metadata;
        this.url = this.data.DataProvider[0].$.url;
      }
    }
    const pd = this.data.DataProvider[0].$;
    return this.playerService.loadProviderData(pd.eventName, pd.source, this.url, folder);
  }

  onCommand(command, param): Observable<any> {
    const cmd = command.$.command;
    switch (cmd) {
      case 'load':
        return this.loadProviderData().pipe(
          catchError( err => of(null)),  // fail to load url
          switchMap( value => this.invalidateData(value) )
        )
      case 'update':
        if (param=="") {
          return of(null);
        }
        return this.invalidateData(param);
      case 'save':
        if (this.playerService.stationId!=-1) {
          const broadcast = command.Params[0].Param[0].$.broadcast == "1";
          return this.playerService.saveDataProvider(this.data.DataProvider[0].$.eventName, this.providerData, broadcast);
        } else {
          alert("For security reasons, saving is only permitted within the deployed SignPlayer")
        }
        break;
    }
    return of(null);
  }
}
